/**
 * Helpers for date-only values (YYYY-MM-DD) without UTC timezone shift.
 * `new Date("2026-06-24")` is UTC midnight → shows as previous day in UTC-6, etc.
 */

export function parseDateOnly(value) {
  if (value == null || value === '') return null;

  if (typeof value === 'string') {
    const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      const year = Number(match[1]);
      const month = Number(match[2]) - 1;
      const day = Number(match[3]);
      return new Date(year, month, day);
    }
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDateOnly(value, locale) {
  const date = parseDateOnly(value);
  if (!date) return typeof value === 'string' ? value : '';
  return date.toLocaleDateString(locale);
}

/** Normalize to YYYY-MM-DD for `<input type="date">`. */
export function toDateInputValue(value) {
  const date = parseDateOnly(value);
  if (!date) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
